import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, BookOpenIcon, ShoppingBagIcon, UsersIcon, BarChart2Icon } from 'lucide-react';
export const BottomNavigation: React.FC = () => {
  const location = useLocation();
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  const navItems = [{
    path: '/',
    icon: HomeIcon,
    label: 'Home'
  }, {
    path: '/dives',
    icon: BarChart2Icon,
    label: 'Dives'
  }, {
    path: '/community',
    icon: UsersIcon,
    label: 'Community'
  }, {
    path: '/learn',
    icon: BookOpenIcon,
    label: 'Learn'
  }, {
    path: '/marketplace',
    icon: ShoppingBagIcon,
    label: 'Shop'
  }];
  return <nav className="fixed bottom-0 left-0 right-0 bg-white shadow-lg z-10 md:hidden" data-id="element-303">
      <div className="flex justify-around items-center h-16" data-id="element-304">
        {navItems.map(item => <Link key={item.path} to={item.path} className={`flex flex-col items-center justify-center w-full h-full px-1 ${isActive(item.path) ? 'text-primary' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-305">
            <item.icon size={20} data-id="element-306" />
            <span className="text-xs mt-1 truncate" data-id="element-307">{item.label}</span>
          </Link>)}
      </div>
    </nav>;
};